import {NgModule} from '@angular/core';
import {SharedModule} from '../shared';
import {CategoryModule} from '../shared/layout/category.module';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {PolicyComponent} from './policy.component';
import {PolicyRoutingModule} from './policy-routing.module';
import {ScrollTopModule} from 'primeng/scrolltop';

@NgModule({
    imports: [
        PolicyRoutingModule,
        SharedModule,
        CategoryModule,
        SharedModule,
        InputTextModule,
        ButtonModule,
        ToastModule,
        ScrollTopModule
    ],
    declarations: [
        PolicyComponent
    ]
})
export class PolicyModule {}
